import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Google Maps is loaded globally via GoogleMapsProvider which is used inside
// UnifiedCourseMap through GoogleMapsContext. We wrap it here so the map API
// is available from the very first render.
import { GoogleMapsProvider } from './context/GoogleMapsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleMapsProvider>
      <App />
    </GoogleMapsProvider>
  </React.StrictMode>
);
